import React from 'react'

import GuideSvg from '../../assets/svg/guide.svg'
import { If } from '../if/if'
import { Container } from './styles'

type Props = {
  title: string;
  instructions?: string[];
  img?: any;
}

const Guide = ({
  title,
  instructions,
  img,
}: Props) => (
  <Container>
    <h3>{title}</h3>
    <img src={img || GuideSvg} alt=" " />
    <If condition={instructions}>
      <ul>
        {
          instructions?.map((instruction: string) => (
            <li key={instruction}>{instruction}</li>
          ))
        }
      </ul>
    </If>
  </Container>
)

Guide.defaultProps = {
  instructions: null,
  img: null,
}

export default Guide
